import React from 'react';

function Skills() {
  return (
    <div class="panel">
      <h1>My Skills</h1>
      <p>My skills are:</p>
      <ul>
        <li>
          <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank" rel="noopener noreferrer">
            JavaScript
          </a>
        </li>
        <li>
          <a href="https://reactjs.org/" target="_blank" rel="noopener noreferrer">
            React
          </a>
        </li>
        <li>
          <a href="https://developer.mozilla.org/en-US/docs/Web/CSS" target="_blank" rel="noopener noreferrer">
            CSS
          </a>
        </li>
        <li>
          <a href="https://www.php.net/" target="_blank" rel="noopener noreferrer">
            PHP
          </a>
        </li>
        <li>
          <a href="https://www.w3schools.com/html/" target="_blank" rel="noopener noreferrer">
            HTML
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Skills;

